// imports here need to be relative because this file gets included in the listing cms
import {getCheckoutClient} from "../../../config/CheckoutClient";
import {wrappedFetch} from "../../../../checkout/helpers/fetch";
import {setReservationData} from "../../../actions/reservation";
import {GATEWAY_TYPE_STRIPE} from "@showclix-shared/Payment/constants/gatewayTypes";
import {updateStripePaymentIntent} from "../../../actions/payment";
import {setLoading} from "../../../actions/loading";
import { isAuthorizedAsUser } from "../../../../checkout/selectors/auth";

export const setLoyaltyAvailable = (amount) => ({
  type: 'SET_LOYALTY_AVAILABLE',
  amount
});

export const setLoyaltyAmount = (amount) => ({
  type: 'SET_LOYALTY_AMOUNT',
  amount
});

export const setLoyaltyError = (error) => ({
  type: 'SET_LOYALTY_ERROR',
  error
});

export function fetchLoyaltyProgramAmount(token, secret) {
  return (dispatch, getState) => {
    let state = getState();
    let programType = state.loyaltyProgram ? state.loyaltyProgram.type : null;
    if (programType == 2 && !isAuthorizedAsUser(state)) {
      return Promise.resolve();
    }
    let programId = state.loyaltyProgram ? state.loyaltyProgram.id : null;
    if (!programId) {
      return Promise.resolve();
    }
    return getCheckoutClient(state.ui.apiUrl).reservationGetRequest(token, 'loyalty/' + programId, secret).then((result) => {
      const amount = result.body.data.attributes.amountAvailable;
      dispatch(setLoyaltyAvailable(amount));
      return Promise.resolve();
    });
  }
}

export function submitLoyaltyRequest(amount) {
  return async (dispatch, getState) => {
    dispatch(setLoading("LOYALTY_REQUEST"));

    try {
      const res = await dispatch(updateLoyaltyAmount(amount));

      const data = await res.json();

      if (res.status !== 200) {
        dispatch(setLoading("LOYALTY_FAILURE"));
        if (data.errors) {
          dispatch(setLoyaltyError(data.errors[0]?.detail));
        }
        return;
      }

      dispatch(processLoyaltyResponse(data));
      dispatch(setLoading("LOYALTY_SUCCESS"));
    } catch (e) {
      dispatch(setLoading("LOYALTY_FAILURE"));
    }
  }
}

export function updateLoyaltyAmount(amount) {
  return async (dispatch, getState) => {
    let state = getState();
    let programId = state.loyaltyProgram ? state.loyaltyProgram.id : null;
    if (!programId) {
      return;
    }
    const payload = {data: {attributes: {program_id: programId, amount: amount}}};
    const req = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Reservation-Secret': state.reservation.secret,
      },
      body: JSON.stringify(payload),
    };
    return wrappedFetch(state.ui.apiUrl + '/reservations/' + state.reservation.token + '/loyalty', req).then((res) => {
      return res;
    });
  }
}

export function processLoyaltyResponse(res) {
  return async (dispatch, getState) => {
    const state = getState();
    const {secret} = state.reservation;
    if (res.reservation_data) {
      dispatch(setReservationData(secret, res.reservation_data));

      if (state.payment.gatewayType === GATEWAY_TYPE_STRIPE) {
        const {total_cost} = getState().reservation;
        await dispatch(
          updateStripePaymentIntent(total_cost?.amount || 0,
            {
              payment_intent_id: state.payment.stripePaymentIntentId,
              client_secret: state.payment.stripePaymentIntentSecret,
            }
          ),
        );
      }
    }

    dispatch(setLoading("LOYALTY_SUBMIT_SUCCESS"));
  }
}
